import pluralize from "pluralize";
import React from "react";

import { cssVariables, Divider, Icon } from "../../../components";
import { Spacer } from "../../spacer";
import styles from "./portal_booking_step_3.module.css";
import { PortalBookingStepLayout } from "./portal_booking_step_layout";
import { PortalBookingSpaceDetails } from "./portal_booking_space_details";
import { UnitUsedDetails } from "./unit_used_details";
import { FAKE_PAYMENT_DETAILS } from "../fake_data";
import { PortalBookingPriceDetails } from "./portal_booking_price_details";
import { BookingType } from "../../../data";
import { isNumber } from "lodash";

interface PortalBookingStep3Props {
  imgUrl: string;
  location: string;
  bookingDate?: string | JSX.Element;
  capacity: number;

  usedCount: number;
  remainingCount?: number;
  bookingEmail: string;
  spaceName: string;
  bookingType: BookingType;
  isUnlimitedPlan?: boolean;
}

export function PortalBookingStep3({
  imgUrl,
  location,
  bookingDate,
  capacity,
  remainingCount,
  usedCount,
  bookingEmail,
  spaceName,
  bookingType,
  isUnlimitedPlan,
}: PortalBookingStep3Props) {
  const renderRightContent = () => {
    if (isUnlimitedPlan) {
      return (
        <UnitUsedDetails
          title={bookingType === BookingType.Daily ? "Day Passes" : "Hours"}
          usedCount={usedCount}
          description={`With your membership, book ${
            bookingType === BookingType.Daily ? "day" : "hour"
          } passes with no monthly limit.`}
        />
      );
    }

    if (isNumber(remainingCount)) {
      if (remainingCount >= 0) {
        return (
          <UnitUsedDetails
            title={
              bookingType === BookingType.Daily
                ? "Passes applied"
                : "Hours used"
            }
            usedCount={usedCount}
            description={`You now have ${remainingCount} remaining ${pluralize(
              bookingType === BookingType.Daily ? "pass" : "hour",
              remainingCount
            )}.`}
            isConfirmation
          />
        );
      } else {
        return <PortalBookingPriceDetails {...FAKE_PAYMENT_DETAILS} />;
      }
    }

    return <></>;
  };

  return (
    <PortalBookingStepLayout
      leftContent={
        <div>
          <div className={styles.title}>
            <Icon name="check-full-circle" color="var(--bs-primary)" />
            <div>Booking confirmed!</div>
          </div>
          <Spacer size={20} />
          <div>
            Thank you for booking with us. A confirmation email has been sent to{" "}
            {bookingEmail}. We are looking forward to seeing you soon.
          </div>
          <Spacer size={24} />
          <Divider color={cssVariables.borderColorDark} />
          <Spacer size={24} />
          <div>
            <div className={styles.dayPassTitle}>{spaceName}</div>
            <Spacer size={16} />
            <PortalBookingSpaceDetails
              imgUrl={imgUrl}
              location={location}
              bookingDate={bookingDate}
              capacity={capacity}
            />
          </div>
        </div>
      }
      rightContent={renderRightContent()}
    />
  );
}
